import React from 'react';
import PropTypes from 'prop-types';
import ChildrenWrapper from '../ChildrenWrapper/ChildrenWrapper';

const LayoutContentWrapper = ({
    isPlaceOrderFlow,
    wrapperClassName,
    wrapperPlaceOrderClassName,
    contentClassName,
    children,
}) => {
    return (
        <div className={isPlaceOrderFlow ? wrapperPlaceOrderClassName : wrapperClassName}>
            {isPlaceOrderFlow ? (
                <div className={contentClassName}>{children}</div>
            ) : (
                <div className={contentClassName}>
                    <ChildrenWrapper>{children}</ChildrenWrapper>
                </div>
            )}
        </div>
    );
};

LayoutContentWrapper.propTypes = {
    isPlaceOrderFlow: PropTypes.bool,
    wrapperClassName: PropTypes.string,
    wrapperPlaceOrderClassName: PropTypes.string,
    contentClassName: PropTypes.string,
    children: PropTypes.node,
};

export default LayoutContentWrapper;
